PageApp.Ent.InPlay = Backbone.Model.extend({})

PageApp.Ent.InPlayImages = Backbone.Model.extend({})

PageApp.Ent.Webcast2Settings = Backbone.Model.extend({})
